<template>
  <div class="regionalManagerWrap">
    <!-- 表单搜索 start -->
    <div class="form-wrap">
      <div class="seach">
        <div class="inputs">
          <el-select
            v-model="formData.logistic_business_id"
            clearable
            placeholder="请选择集配中心"
          >
            <el-option
              v-for="item of options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-input
            v-model="formData.fullname"
            clearable
            placeholder="请输入区域负责人"
          >
          </el-input>
        </div>
        <div class="inputs">
          <el-input
            v-model="formData.mobile"
            clearable
            placeholder="请输入电话"
          >
          </el-input>
        </div>
        <div class="inputs">
          <el-select
            v-model="formData.province_code"
            clearable
            placeholder="请选择管辖区域(省)"
          >
            <el-option
              v-for="item in province_list"
              :key="item.area_code"
              :label="item.name"
              :value="item.area_code"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-select
            v-model="formData.city_code"
            clearable
            placeholder="请选择管辖区域(市)"
          >
            <el-option
              v-for="item in city_list"
              :key="item.area_code"
              :label="item.name"
              :value="item.area_code"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-select
            v-model="formData.logistics_id"
            clearable
            filterable
            placeholder="请选择城市仓"
          >
            <el-option
              v-for="item of tdcList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-date-picker
            type="daterange"
            :clearable="false"
            v-model="change_time"
            start-placeholder="供货周期起"
            end-placeholder="供货周期止"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="(val) => addTimeChange(val)"
          >
          </el-date-picker>
        </div>
        <div class="inputs">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="refresh"
            @click="onHandleRefresh"
          ></el-button>
          <el-button @click="onSearch" type="primary" icon="el-icon-search"
            >查询</el-button
          >
          <el-button type="primary" @click="editPop('新增')">添加</el-button>
          <el-button
            type="warning"
            :disabled="!tableData.length || disabledExport"
            @click="exportHandle"
            icon="el-icon-download"
            >导 出</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="fullname"
          align="center"
          label="区域负责人"
          min-width="150"
        >
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="电话">
        </el-table-column>
        <el-table-column
          prop="area_list_txt"
          align="center"
          label="管辖区域"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="register_num"
          align="center"
          label="新开客"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="register_user_total"
          align="center"
          label="累计新开客"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="creator_user_total"
          align="center"
          label="累计建档客户"
        >
        </el-table-column>
        <el-table-column
          prop="sales_qty"
          align="center"
          label="销量(件)"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="sales_tonnage"
          align="center"
          label="销量(吨)"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="follow_record_num"
          align="center"
          label="回访数量"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="follow_record_90_num"
          align="center"
          label="90天内总回访占比"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="logistics
"
          align="center"
          label="管辖城市仓"
          min-width="150"
        >
          <template slot-scope="scope">
            {{ getLogistics(scope.row.logistics) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state_txt"
          align="center"
          label="状态"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="op_name"
          align="center"
          label="操作"
          fixed="right"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="editPop('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 start -->
    <editManager
      ref="infoPop"
      :tdcList="tdcList"
      :options="options"
      :areaList="areaList"
      @submit-form="onHandleRefresh"
    />
    <!-- 新增/编辑弹窗 end -->
  </div>
</template>
<script>
import { postRegionalManageExport } from "@/api/export/center.js";
import CPreviewFile from "@/components/common/CPreviewFile/index.vue";
import editManager from "./modules/editManager.vue";
import { formatDate } from "@/utils//tools/date.js";
import {
  postAreaChildList,
  postRegionalManageList,
  postAreaTree,
} from "@/api/general/manager.js";

export default {
  name: "regional-manager",
  components: {
    CPreviewFile,
    editManager,
  },
  data() {
    return {
      options: [],
      change_time: [],
      loading: false,
      disabledExport: false, // 导出禁用
      formData: {
        page: 1, //	number	页码
        pageSize: 20, //	number	页大小
        logistic_business_id: "",
        fullname: "",
        mobile: "",
        province_code: "",
        logistics_id: "",
        city_code: "",
        start_date: "",
        end_date: "",
      }, // 表单参数
      tableData: [], // 城市仓列表
      total: 0,
      tdcList: [],
      province_list: [],
      city_list: [],
      areaList: [],
    };
  },
  mounted() {
    console.log(this.$route.query.id);
    this.formData.supplier_id = this.$route.query.id
      ? this.$route.query.id
      : "";
    // 增加默认日期
    const now = new Date(); // 当前日期
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    // 当月第一天
    const firstDay = new Date(currentYear, currentMonth, 1);
    // 直接使用当前日期（now）作为结束日期
    this.change_time = [
      formatDate(firstDay),
      formatDate(), // 注意：这里使用now而不是lastDay
    ];
    this.formData.start_date = formatDate(firstDay);
    this.formData.end_date = formatDate();
    this.onInitData();
  },
  methods: {
    // 管辖区域
    async postAjaxAreaTree() {
      try {
        const res = await postAreaTree({
          level: 2,
        });
        this.areaList = res.data || [];
        console.log(res, "res=");
      } catch (error) {}
    },
    // 获取城市仓列表
    async getlogisticsselect() {
      try {
        const res = await this.$api.Followup.logisticsselect();
        this.tdcList = res.data;
      } catch (error) {
        console.log(error, "logisticsselect");
      }
    },
    // 服务区域 省市区列表
    async postAjaxAreaChildList(e) {
      try {
        const res = await postAreaChildList({
          parent_code: "",
          level: e,
        });
        if (e == 1) {
          this.province_list = res.data || []; // 省
        }
        if (e == 2) {
          this.city_list = res.data || []; // 市
        }
      } catch (error) {
        console.log(error, "postAreaChildList");
      }
    },
    // 获取管理城市仓
    getLogistics(arr) {
      const nameArr = arr.map((item) => item.name).join(",");
      return nameArr;
    },
    // 新增/编辑
    editPop(type, row) {
      this.$refs.infoPop.onInitData(row, type);
    },
    // 获取集配中心
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.options = res.data;
      });
    },
    // 初始化
    onInitData() {
      this.getBusinessList();
      this.getlogisticsselect();
      this.postAjaxAreaChildList(1);
      this.postAjaxAreaChildList(2);
      this.postAjaxAreaTree();
      this.hqlist();
    },
    // 获取列表
    async hqlist() {
      this.loading = true;
      try {
        const res = await postRegionalManageList(this.formData);
        this.loading = false;
        this.tableData = res.data.data;
        this.total = res.data.total;
      } catch (error) {
        console.log(error, "postRegionalManageList");
      }
    },
    /**
     * 导出明细
     */
    async exportHandle() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postRegionalManageExport(query);
        this.goExportCenter();
      } catch (err) {
        this.disabledExport = false;
        console.log(
          "ajax postSettlementSupplierServiceChargesSkuDetailExport err",
          err
        );
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      Object.assign(this.$data.formData, this.$options.data().formData);

      // 增加默认日期
      const now = new Date(); // 当前日期
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      // 当月第一天
      const firstDay = new Date(currentYear, currentMonth, 1);
      // 直接使用当前日期（now）作为结束日期
      this.change_time = [
        formatDate(firstDay),
        formatDate(), // 注意：这里使用now而不是lastDay
      ];
      this.formData.start_date = formatDate(firstDay);
      this.formData.end_date = formatDate();

      this.hqlist();
    },
    /**
     * 搜索表单
     */
    onSearch() {
      this.formData.page = 1;
      this.hqlist();
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.hqlist();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.hqlist();
    },
    // 修改时间
    addTimeChange(val) {
      if (val) {
        this.formData.start_date = val[0];
        this.formData.end_date = val[1];
      } else {
        this.formData.start_date = "";
        this.formData.end_date = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-image {
  width: 70px;
  height: 70px;
}

.regionalManagerWrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .form-wrap {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    .seach {
      flex: 1;
      display: flex;
      // justify-content: flex-start !important;
      //   justify-content: flex-end;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .inputs {
        display: flex;
        align-items: center;
        //.divname {
        //    width: 100px;
        //   }
        // width: 207px;
        // margin-right: 8px;
      }
    }
    .refresh {
      background: #333333;
      border-color: #333333;
    }
  }
  .table-wrap {
    flex: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
    .el-button {
      &--text {
        padding: 10px 0;
      }
    }
  }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;
  }
  .base-margin {
    margin: 0 10px;
    white-space: nowrap;
  }
  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
